import {
    createRegisterableComponentWithData,
    ePaperLatestEditionDataDefinationLoader,
    Issue,
} from '@news-mono/web-common'
import React from 'react'
import EPaperPage from './ePaperPage'

export interface ePaperPageRouteProps {
    latestIssues?: Issue[]
}

export const ePaperPageRegistration = createRegisterableComponentWithData(
    'epaper-page',
    ePaperLatestEditionDataDefinationLoader,
    ({}, data, services) => {
        console.log(data, 'this should be the API response data')
        if (data.loaded) {
            return (
                <EPaperPage
                    latestEdition={data.result.latestIssues[0]}
                    allEditions={data.result.latestIssues}
                    onEvent={services.onEvent}
                />
            )
        }
        return (
            //maybe send down some default values if data no loaded
            null
        )
    },
)
